import { useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../../components/SideBar";
import { ReportParamsContext } from "../../context/ReportParamsContext";
import ReportParametersSelector from "../../components/ReportParametersSelector";

export default function ReportsLayout({ sideBarItems }) {
  const [searchText, setSearchText] = useState("");
  const [commonParams, setCommonParams] = useState({
    manufacturer: null,
    fromDate: "",
    toDate: "",
    provinces: [],
    territories: [],
    representatives: [],
  });

  return (
    <>
      <SideBar items={sideBarItems} />
      <ReportParamsContext.Provider value={[commonParams, setCommonParams]}>
        <div className="d-flex flex-column flex-grow-1 overflow-hidden">
          <ReportParametersSelector />
          <Outlet context={[searchText, setSearchText]} />
        </div>
      </ReportParamsContext.Provider>
    </>
  );
}
